// extracted by mini-css-extract-plugin
module.exports = {"thetable":"Home_thetable_1myiP","form-grid":"Home_form-grid_3vsQ-"};